<template>
  <div>
    <el-form ref="formDynamicRef" size="small" :model="formDynamic" :rules="rules" class="attrFrom mb20"
      label-width="100px" @submit.prevent>
      <el-row :gutter="24">
        <el-col :span="12" :xs="24">
          <el-form-item label="模板名称：" prop="templateName">
            <!-- 固定最小宽度：弹窗未撑开时避免 EP 默认 420px + span 栅格把输入压成竖条 -->
            <el-input v-model="formDynamic.templateName" placeholder="请输入模板名称" class="attr-tpl-input" />
          </el-form-item>
        </el-col>
        <el-col v-for="(item, index) in formDynamic.templateValue" :key="index" :span="24" class="noForm">
          <el-form-item>
            <div class="acea-row row-middle">
              <span class="mr5">{{ item.value }}</span>
              <el-icon class="el-icon-circle-close" @click="handleRemove(index)">
                <Close />
              </el-icon>
            </div>
            <div class="rulesBox">
              <el-tag v-for="(j, indexn) in item.detail" :key="indexn" closable size="medium"
                :disable-transitions="false" class="mb5 mr10" @close="handleClose(item.detail, indexn)">
                {{ j }}
              </el-tag>
              <el-input v-if="item.inputVisible" :ref="`saveTagInputRef${index}`" v-model="item.attrsVal" class="input-new-tag"
                size="small" maxlength="30" @keyup.enter="createAttr(item.attrsVal || '', index)"
                @blur="createAttr(item.attrsVal || '', index)" />
              <el-button v-else class="button-new-tag" size="small" @click="showInput(item,index)">+ 添加</el-button>
            </div>
          </el-form-item>
        </el-col>
        <el-col v-if="isBtn" :span="24" class="mt10" style="padding-left: 0;padding-right: 0;">
          <el-col :span="8">
            <el-form-item label="规格：">
              <el-input v-model="attrsName" maxlength="30" placeholder="请输入规格" class="attr-tpl-input" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="规格值：">
              <el-input v-model="attrsVal" maxlength="30" placeholder="请输入规格值" class="attr-tpl-input" />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-button type="primary" class="mr10" @click="createAttrName">确定</el-button>
            <el-button @click="offAttrName">取消</el-button>
          </el-col>
        </el-col>
        <el-loading v-if="spinShow" size="large" />
      </el-row>
      <el-form-item>
        <el-button v-if="!isBtn" type="primary" class="mt10" @click="addBtn">添加新规格</el-button>
      </el-form-item>
    </el-form>
    <span class="footer acea-row">
      <el-button @click="resetForm">取消</el-button>
      <el-button :loading="loading" type="primary" @click="handleSubmit">确 定</el-button>
    </span>
  </div>
</template>

<script setup lang="ts">
import {ref, reactive, watch, onMounted, nextTick, getCurrentInstance} from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Close } from '@element-plus/icons-vue'
import { attrCreatApi, attrEdittApi } from '@/api/product'

interface TemplateValue {
  value: string
  detail: any[]
  inputVisible?: boolean
  attrsVal?: string
}

interface FormDynamic {
  templateName: string
  templateValue: TemplateValue[]
}

interface Props {
  currentRow: any
  onGetList?: () => void
}

const { proxy } = getCurrentInstance()!

const props = defineProps<Props>()
const emit = defineEmits<{ getList: [] }>()

// 定义 props 类型
interface Props {
  currentRow: any
  onGetList?: () => void
}

const formDynamicRef = ref()
const saveTagInputRef = ref()

const dialogVisible = ref(false)
const inputVisible = ref(false)
const inputValue = ref('')
const spinShow = ref(false)
const loading = ref(false)
const index = ref(1)

const rules = {
  templateName: [
    { required: true, message: '请输入模板名称', trigger: 'blur' }
  ]
}

const formDynamic = reactive<FormDynamic>({
  templateName: '',
  templateValue: []
})

const attrsName = ref('')
const attrsVal = ref('')
const formDynamicNameData = ref([])
const isBtn = ref(false)
const formDynamicName = ref([])
const results = ref([])
const result = ref([])
const ids = ref(0)

// 监听 currentRow 变化
watch(() => props.currentRow, (val) => {
  if (val) {
    Object.assign(formDynamic, val)
    // 为每个 templateValue 添加 inputVisible 属性
    formDynamic.templateValue.forEach(item => {
      item.inputVisible = false
    })
  }
}, { immediate: true })

onMounted(() => {
  formDynamic.templateValue.forEach(item => {
    item.inputVisible = false
  })
})

// 重置表单
function resetForm() {
  ElMessageBox.close()
  clear()
  formDynamicRef.value?.resetFields()
}

// 添加按钮
function addBtn() {
  isBtn.value = true
}

// 关闭标签
function handleClose(item: string[], index: number) {
  item.splice(index, 1)
}

// 取消
function offAttrName() {
  isBtn.value = false
}

// 删除
function handleRemove(index: number) {
  formDynamic.templateValue.splice(index, 1)
}

// 添加规则名称
function createAttrName() {
  if (attrsName.value && attrsVal.value) {
    const data: TemplateValue = {
      value: attrsName.value,
      detail: [attrsVal.value]
    }
    formDynamic.templateValue.push(data)

    // 去重处理
    const hash: Record<string, boolean> = {}
    formDynamic.templateValue = formDynamic.templateValue.reduce((item: TemplateValue[], next: TemplateValue) => {
      if (!hash[next.value]) {
        hash[next.value] = true
        item.push(next)
      }
      return item
    }, [])

    attrsName.value = ''
    attrsVal.value = ''
    isBtn.value = false
  } else {
    if (!attrsName.value) {
      ElMessage.warning('请输入规格名称！')
      return
    }
    if (!attrsVal.value) {
      ElMessage.warning('请输入规格值！')
      return
    }
  }
}

// 添加属性
function createAttr(num: string, idx: number) {
  if (num) {
    formDynamic.templateValue[idx].detail.push(num)

    // 去重处理
    const hash: Record<string, boolean> = {}
    formDynamic.templateValue[idx].detail = formDynamic.templateValue[idx].detail.reduce((item: string[], next: string) => {
      if (!hash[next]) {
        hash[next] = true
        item.push(next)
      }
      return item
    }, [])

    formDynamic.templateValue[idx].inputVisible = false
  } else {
    ElMessage.warning('请添加属性')
  }
}

// 显示输入框
function showInput(item: TemplateValue,index:number) {
  item.inputVisible = true
  setTimeout(() => {
        (proxy?.$refs[`saveTagInputRef${index}`] as any)[0].focus()
  })
}

// 提交
function handleSubmit() {
  formDynamicRef.value?.validate((valid: boolean) => {
    if (valid) {
      if (formDynamic.templateValue.length === 0) {
        ElMessage.warning('请至少添加一条属性规格！')
        return
      }

      loading.value = true
      setTimeout(() => {
        if (props.currentRow?.attrTemplateId) {
          // 编辑
          attrEdittApi(props.currentRow.attrTemplateId, formDynamic).then((res: any) => {
            ElMessage.success(res.message)
            loading.value = false
            setTimeout(() => {
              ElMessageBox.close()
            }, 500)
            setTimeout(() => {
              clear()
              emit('getList')
              props.onGetList?.()
            }, 600)
          }).catch((res: any) => {
            loading.value = false
            ElMessage.error(res.message)
          })
        } else {
          // 创建
          attrCreatApi(formDynamic).then((res: any) => {
            ElMessage.success(res.message)
            loading.value = false
            setTimeout(() => {
              ElMessageBox.close()
            }, 500)
            setTimeout(() => {
              emit('getList')
              props.onGetList?.()
              clear()
            }, 600)
          }).catch((res: any) => {
            loading.value = false
            ElMessage.error(res.message)
          })
        }
      }, 1200)
    } else {
      return false
    }
  })
}

// 清空
function clear() {
  formDynamicRef.value?.resetFields()
  formDynamic.templateValue = []
  formDynamic.templateName = ''
  isBtn.value = false
  attrsName.value = ''
  attrsVal.value = ''
}

// 输入确认
function handleInputConfirm() {
  const value = inputValue.value
  if (value) {
    // 这里需要根据实际需求处理
  }
  inputVisible.value = false
  inputValue.value = ''
}
</script>

<style scoped lang="scss">
.attrFrom {
  width: 100%;

  :deep(.el-form-item__content) {
    flex: 1;
    min-width: 0;
  }

  :deep(.attr-tpl-input) {
    width: 100%;
    min-width: 250px;
  }

  :deep(.attr-tpl-input .el-input__wrapper) {
    width: 100%;
  }
}

.button-new-tag {
  height: 28px;
  line-height: 26px;
  padding-top: 0;
  padding-bottom: 0;
}

.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}

.footer {
  justify-content: flex-end;
}

.acea-row {
  display: flex;
  align-items: center;
}

.row-middle {
  align-items: center;
}

.mr5 {
  margin-right: 5px;
}

.mr10 {
  margin-right: 10px;
}

.mb5 {
  margin-bottom: 5px;
}

.mb20 {
  margin-bottom: 20px;
}

.mt10 {
  margin-top: 10px;
}

.noForm {
  margin-bottom: 20px;
}

.rulesBox {
  margin-top: 10px;
}
</style>
